export default __webpack_public_path__ + "static/media/pvilla7-1.3f19fb4b.webp";